import React from "react";
import styled from "styled-components";
import { LabelTextStyle } from "../../../common/StyledComponents";
import { service_type_options } from "../../../../helpers/GlobalOptions";
import ServiceFormChildren1 from "./ServiceForm1Comp/ServiceForm_children_1";

function ServiceForms_1({
  form,
  onChangeType,
  onChangeHandler,
  onSelectType,
  errors,
  searching,
}) {
  const onChangeTypeFunc = (type) => {
    const targetVal = { target: { value: type, name: "type" } };
    onChangeType(targetVal, "form");
  };

  return (
    <>
      <div className="row justify-content-between mx-0 mb-2">
        {service_type_options.map((i) => (
          <LargeButton
            key={i.label}
            key={i.label}
            disabled={i.label === "Pre-trade"}
            className={`btn btn-lg ${form.type == i.label && "button_active"}`}
            onClick={() => onChangeTypeFunc(i.label)}
          >
            {i.label}
          </LargeButton>
        ))}
      </div>
      {errors.type && (
        <div className="text-center text-danger">{errors.type}</div>
      )}
      {form.type == "" ? (
        <div></div>
      ) : (
        <>
          <LabelTextStyle>Purchase</LabelTextStyle>
          <ServiceFormChildren1
            form={form}
            onChangeHandler={onChangeHandler}
            onSelectType={onSelectType}
            errors={errors}
            searching={searching}
          />
        </>
      )}
    </>
  );
}

const LargeButton = styled.button`
  background-color: #f6f6f6;
  font-size: 17px;
  border-radius: 2px;
  height: 70px;
  width: 18%;
  &.button_active {
    background-color: #fff;
    border: 1px solid #f7931e;
  }
  &:hover {
    background-color: #fff;
    border: 1px solid #f7931e;
    color: #f7931e;
  }
`;

export default ServiceForms_1;
